import { useEffect, useState } from "react";
import { IoDocumentOutline, IoDocumentsOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { getAccountDocumentsAsync } from "./../../../../services/documentService";

const Documents = ({ id, params }) => {
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchDocuments = async () => {
      setIsLoading(true);

      const response = await getAccountDocumentsAsync(id, params);
      const { result } = response;

      if (mounted) {
        setDocuments(result);
        setIsLoading(false);
      }
    };

    fetchDocuments();

    return () => {
      mounted = false;
    };
  }, [id, params]);

  return (
    <>
      <div className="p-5">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-500">Documents</p>
            <span className="text-xs text-gray-400">
              List of Uploaded Documents
            </span>
          </div>
        </div>
        <div className="mt-6 mb-4">
          {isLoading && (
            <div className="flex-1 space-y-3 py-1 animate-pulse">
              <div className="h-4 bg-gray-100 rounded w-3/5"></div>
              <div className="h-4 bg-gray-100 rounded w-5/5"></div>
              <div className="h-4 bg-gray-100 rounded w-4/5"></div>
              <div className="h-4 bg-gray-100 rounded w-2/5"></div>
            </div>
          )}
          {!isLoading && documents.length > 0 && (
            <ul className="border border-gray-200 rounded-md divide-y divide-gray-200">
              {documents.map((item) => (
                <li
                  key={item.id}
                  className="pl-3 pr-4 py-3 flex items-center text-gray-400 text-sm"
                >
                  <IoDocumentOutline className="mr-4" />
                  <a
                    href={item.s3_reference_name}
                    className="hover:text-blue-400 truncate"
                    rel="noreferrer"
                    target="_blank"
                  >
                    {item.document_name}
                  </a>
                </li>
              ))}
            </ul>
          )}
          {!isLoading && documents.length === 0 && (
            <div className="text-center bg-gray-50 p-8 rounded-xl mb-2">
              <div className="flex justify-center">
                <div>
                  <IoDocumentsOutline className="text-3xl inline text-gray-300" />
                  <p className="text-gray-400 text-sm mt-3">Nothing to show</p>
                  <span className="text-gray-400 text-xs">
                    Any new documents will appear here
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="mt-2 flex flex-row-reverse">
          <Link
            className="text-blue-400 text-sm"
            to={`/accounts/documents/${id}`}
          >
            View All Documents
          </Link>
        </div>
      </div>
    </>
  );
};

export default Documents;
